// WingWise testIds — data-testid registry
export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  workspaceInput: 'auth-workspace-input',
  loginBtn: 'auth-login-btn',
  registerBtn: 'auth-register-btn',
  logoutBtn: 'nav-logout-btn',
  mfaCodeInput: 'auth-mfa-code-input',
};

export const NAV = {
  dashboard: 'nav-dashboard',
  positions: 'nav-positions',
  journal: 'nav-journal',
  learning: 'nav-learning',
  settings: 'nav-settings',
  audit: 'nav-audit',
  killSwitch: 'nav-kill-switch',
  killSwitchActivate: 'kill-switch-activate',
  killSwitchDeactivate: 'kill-switch-deactivate',
  killSwitchBanner: 'kill-switch-banner',
};

export const DASH = {
  root: 'dashboard-root',
  equity: 'dashboard-equity',
  cash: 'dashboard-cash',
  openPositions: 'dashboard-open-positions',
  watchlist: 'dashboard-watchlist',
  addSymbolInput: 'watchlist-add-symbol-input',
  addSymbolBtn: 'watchlist-add-symbol-btn',
  symbolPreview: 'watchlist-symbol-preview',
  symbolPreviewName: 'watchlist-symbol-preview-name',
  symbolRow: (s) => `watchlist-symbol-${s}`,
  symbolCompany: (s) => `watchlist-company-${s}`,
  runAnalysis: (s) => `run-analysis-${s}`,
};

export const PROP = {
  root: 'proposal-root',
  analystCard: 'proposal-analyst-card',
  criticCard: 'proposal-critic-card',
  consensusCard: 'proposal-consensus-card',
  riskCard: 'proposal-risk-card',
  plansTable: 'proposal-plans-table',
  planRow: (id) => `proposal-plan-row-${id}`,
  selectPlan: (id) => `proposal-plan-select-${id}`,
  entryInput: 'proposal-entry-input',
  stopInput: 'proposal-stop-input',
  targetInput: 'proposal-target-input',
  qtyInput: 'proposal-qty-input',
  riskCheckBtn: 'proposal-risk-check-btn',
  approveBtn: 'proposal-approve-btn',
  rejectBtn: 'proposal-reject-btn',
  suggestedModsCard: 'proposal-suggested-mods',
  applyAllSuggestions: 'proposal-apply-all-suggestions',
  applySuggestion: 'proposal-apply-suggestion',
};

export const POS = {
  root: 'positions-root',
  row: (id) => `position-row-${id}`,
  closeBtn: (id) => `position-close-${id}`,
};

export const JOURNAL = {
  root: 'journal-root',
  row: (id) => `journal-row-${id}`,
  reviewModal: 'review-modal',
  outcome: (o) => `review-outcome-${o}`,
  primaryCause: 'review-primary-cause',
  notesInput: 'review-notes-input',
  submitBtn: 'review-submit-btn',
};

export const SETTINGS = {
  root: 'settings-root',
  brokerModeSelect: 'settings-broker-mode',
  brokerKeyInput: 'settings-broker-key',
  brokerSecretInput: 'settings-broker-secret',
  brokerConnectBtn: 'settings-broker-connect',
  brokerDisconnectBtn: 'settings-broker-disconnect',
  riskProfileForm: 'settings-risk-form',
  riskSaveBtn: 'settings-risk-save',
  inviteEmail: 'settings-invite-email',
  inviteBtn: 'settings-invite-btn',
  mfaSetupBtn: 'settings-mfa-setup',
  mfaVerifyCode: 'settings-mfa-verify-code',
  mfaVerifyBtn: 'settings-mfa-verify-btn',
};

export const LEARN = {
  root: 'learning-root',
  winRate: 'learn-win-rate',
  totalPnl: 'learn-total-pnl',
  analystAcc: 'learn-analyst-acc',
  criticAcc: 'learn-critic-acc',
};

// legacy home (kept for existing exports)
export const HOME = { emergentLink: 'home-emergent-link' };
